export default "__VITE_ASSET__f22c63a8__"